import React from "react"

export const SpinnerRow = () => {
  return (
    <div className="row">
      <div className="col-12 offset-xl-1 col-xl-10 d-flex flex-column align-items-center gap-3">
        <i className="fas fa-spinner fa-spin"/>
      </div>
    </div>
  )
}
